import { Link } from "react-router-dom";

import { useDispatch } from "react-redux";
import { toggleVerify } from "../../Redux/reducers/verifySlice";

const NotVerified = () => {

    const dispatch = useDispatch();
    return (
        <div className='col-12 d-flex justify-content-center align-items-center my-3'>
            <div className='col-8 text-center small p-2 shadow rounded my-5'>
                <img alt="logo" style={{ objectFit: "contain", height: "20vh", width: "20vh" }} src="/assets/images/logo.png" />
                <p>You are not verified. Please <span onClick={() => { dispatch(toggleVerify(true)) }} className="cursor-pointer text-primary">verify</span> to view or post your product.</p>
                <p>Go back to <Link href="/">home</Link></p>
            </div>
        </div>
    );
}

export default NotVerified;